<!-- eslint-disable vue/no-mutating-props -->
<!-- 门店统计、营业设置与门店维护的弹窗模块。表单状态由父页面集中管理。 -->
<template>
  <el-dialog
    :model-value="storeStatsVisible"
    title="门店经营统计"
    width="680px"
    @update:model-value="emit('update:storeStatsVisible', $event)"
  >
    <template v-if="selectedStore && selectedStoreStats">
      <div class="detail-grid detail-grid--single">
        <article class="detail-card">
          <h3>{{ selectedStore.name }}</h3>
          <dl>
            <div><dt>今日订单数</dt><dd>{{ selectedStoreStats.todayOrderCount }}</dd></div>
            <div><dt>今日营业额</dt><dd>{{ formatAmount(selectedStoreStats.todayRevenue) }}</dd></div>
            <div><dt>本月订单数</dt><dd>{{ selectedStoreStats.monthOrderCount }}</dd></div>
            <div><dt>本月营业额</dt><dd>{{ formatAmount(selectedStoreStats.monthRevenue) }}</dd></div>
          </dl>
        </article>
      </div>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="storeSettingsVisible"
    title="营业设置"
    width="760px"
    @update:model-value="emit('update:storeSettingsVisible', $event)"
  >
    <div v-if="selectedStore" class="detail-grid detail-grid--single">
      <article class="detail-card">
        <h3>{{ selectedStore.name }}</h3>
        <div class="detail-actions">
          <GuidedField label="开门时间" hint="门店开始接单的时间，如 08:00。" required>
            <AdminTimePicker v-model="storeSettingsForm.openTime" placeholder="请选择开门时间" />
          </GuidedField>
          <GuidedField label="关门时间" hint="门店停止接单的时间，如 22:00。" required>
            <AdminTimePicker v-model="storeSettingsForm.closeTime" placeholder="请选择关门时间" />
          </GuidedField>
          <GuidedField label="自提准备时间" hint="用户下单后，门店准备自提订单所需分钟数。">
            <el-input v-model.number="storeSettingsForm.pickupPrepareMinutes" placeholder="如 10" />
          </GuidedField>
          <GuidedField label="配送准备时间" hint="订单交给配送员前预计需要的分钟数。">
            <el-input v-model.number="storeSettingsForm.deliveryPrepareMinutes" placeholder="如 15" />
          </GuidedField>
          <GuidedField label="接单状态" hint="暂停接单期间，门店不会接收新订单。">
            <el-select v-model="storeSettingsForm.suspendOrdering">
              <el-option label="正常接单" :value="false" />
              <el-option label="暂停接单" :value="true" />
            </el-select>
          </GuidedField>
          <GuidedField label="暂停原因" hint="展示给后台人员的内部备注，选填。" wide>
            <el-input v-model.trim="storeSettingsForm.suspendReason" placeholder="如 设备维护、临时闭店" />
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:storeSettingsVisible', false)">取消</el-button>
      <el-button type="primary" :loading="storeSettingsSubmitting" @click="emit('submitStoreSettings')">保存设置</el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="storeEditorVisible"
    :title="isEditingStore ? '编辑门店' : '新增门店'"
    width="760px"
    @update:model-value="emit('update:storeEditorVisible', $event)"
  >
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="门店名称" hint="展示在用户端和订单中的门店名称。" required>
            <el-input v-model.trim="storeForm.name" placeholder="如 中山公园店" />
          </GuidedField>
          <GuidedField label="门店编码" hint="系统内部标识；留空时自动生成。">
            <el-input v-model.trim="storeForm.code" placeholder="如 ZSPY-001" />
          </GuidedField>
          <GuidedField label="联系电话" hint="用于联系门店处理订单或售后。">
            <el-input v-model.trim="storeForm.phone" placeholder="如 021-12345678" />
          </GuidedField>
          <GuidedField label="门店图片" hint="展示在小程序首页门店卡片中。" wide>
            <LocalImagePicker v-model="storeForm.imageUrl" button-text="上传门店图片" />
          </GuidedField>
          <GuidedField label="门店类别" hint="用于小程序首页食品分类入口筛选门店。" wide>
            <el-select v-model="storeForm.categories" multiple clearable placeholder="请选择门店类别">
              <el-option
                v-for="category in storeCategoryOptions"
                :key="category"
                :label="category"
                :value="category"
              />
            </el-select>
          </GuidedField>
          <GuidedField label="营业状态" hint="决定门店当前是否可以接单。">
            <el-select v-model="storeForm.businessStatus">
              <el-option v-for="option in storeStatusOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </GuidedField>
          <GuidedField label="门店地址" hint="请选择省市区并填写详细地址，用于用户查看和配送定位。" wide>
            <StoreLocationPicker
              v-model:address="storeForm.address"
              v-model:longitude="storeForm.longitude"
              v-model:latitude="storeForm.latitude"
            />
          </GuidedField>
          <GuidedField label="开门时间" hint="门店开始营业的时间，如 08:00。">
            <AdminTimePicker v-model="storeForm.openTime" placeholder="请选择开门时间" />
          </GuidedField>
          <GuidedField label="关门时间" hint="门店停止营业的时间，如 22:00。">
            <AdminTimePicker v-model="storeForm.closeTime" placeholder="请选择关门时间" />
          </GuidedField>
          <GuidedField label="无人机配送" hint="仅在已配置无人机配送能力时开启。">
            <el-select v-model="storeForm.supportsDrone">
              <el-option label="支持无人机" :value="true" />
              <el-option label="不支持无人机" :value="false" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:storeEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="storeSubmitting" :disabled="!storeForm.name" @click="emit('submitStore')">
        {{ isEditingStore ? '保存修改' : '创建门店' }}
      </el-button>
    </template>
  </el-dialog>

</template>

<script setup lang="ts">
import { computed } from 'vue'
import AdminTimePicker from '@/components/AdminTimePicker.vue'
import GuidedField from '@/components/GuidedField.vue'
import LocalImagePicker from '@/components/LocalImagePicker.vue'
import StoreLocationPicker from '@/components/StoreLocationPicker.vue'
import type { AdminStore, StoreSavePayload, StoreStats } from '@/api/store'
import { STORE_CATEGORY_OPTIONS } from '@jiaofa/constants'

interface StoreSettingsForm {
  openTime: string
  closeTime: string
  suspendOrdering: boolean
  suspendReason: string
  pickupPrepareMinutes: number
  deliveryPrepareMinutes: number
}

interface StoreStatusOption {
  value: string
  label: string
}

const props = defineProps<{
  storeStatsVisible: boolean
  storeSettingsVisible: boolean
  storeEditorVisible: boolean
  selectedStore?: AdminStore
  selectedStoreStats?: StoreStats
  storeSettingsForm: StoreSettingsForm
  storeForm: StoreSavePayload
  storeStatusOptions: StoreStatusOption[]
  storeSettingsSubmitting: boolean
  storeSubmitting: boolean
  formatAmount: (amount: number) => string
}>()

const emit = defineEmits<{
  'update:storeStatsVisible': [value: boolean]
  'update:storeSettingsVisible': [value: boolean]
  'update:storeEditorVisible': [value: boolean]
  submitStoreSettings: []
  submitStore: []
}>()

const isEditingStore = computed(() => Boolean(props.storeForm.id))
const storeCategoryOptions = STORE_CATEGORY_OPTIONS
</script>

<style scoped lang="scss">
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.detail-grid--single { grid-template-columns: 1fr; }
.detail-card { padding: 16px; border: 1px solid var(--jf-color-border); border-radius: 12px; background: #fff; }
.detail-card h3 { margin: 0 0 14px; font-size: 16px; }
.detail-card dl { margin: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 12px 16px; }
.detail-card dl div { min-width: 0; }
.detail-card dt { margin-bottom: 4px; color: var(--jf-color-text-secondary); font-size: 12px; }
.detail-card dd { margin: 0; color: var(--jf-color-text-primary); font-size: 14px; word-break: break-all; }
.detail-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
@media (max-width: 760px) {
  .detail-grid, .detail-card dl, .detail-actions { grid-template-columns: 1fr; }
}
</style>
